export const tableActionTypes = {
  resetSelectedItems: '[Table] - reset selected items in table',
  togglePositionStatus: '[Position Table] - toggle position status',
  showBulkEditBar: '[Table] - is show bulk edit bar',
};
